import { Container, withStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import Breadcrumbs from "../../components/Breadcrumbs";
import styles from "./styles";
import { NEWS_IMAGE_BASE_URL } from "../../constants/ui";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import * as generalActions from "../../actions/general";
import Seo from "../../components/Seo";

function NewsDetail(props) {
  const { classes, generalActionCreators, newsDetail, match, history } = props;
  const { fetchNewsContent } = generalActionCreators;

  const { seoNews } = history.location.state;

  useEffect(() => {
    const { id } = match.params;
    fetchNewsContent(id);
  }, [fetchNewsContent, match.params]);

  const mapParams = () => {
    let params = [{ name: "Tin tức", cate: "news", to: "/tin-tuc" }];

    if (newsDetail) {
      params.push({
        name: newsDetail.name,
        cate: "news-child",
        to: newsDetail.alias
      });
    }

    return params;
  };

  return (
    <>
      <Seo seoContent={ newsDetail.seo_title !==""? newsDetail:seoNews} />
      <Breadcrumbs params={mapParams()} />
      <Container className={classes.container}>
        <h2>{newsDetail.name}</h2>
        <div
          className={classes.desc}
          dangerouslySetInnerHTML={{ __html: newsDetail.description }}
        />
        <img
          className={classes.img}
          alt="img"
          src={`${NEWS_IMAGE_BASE_URL}/${newsDetail.picture}?time=`+ Date.now()}
        />
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{ __html: newsDetail.content }}
        />
      </Container>
    </>
  );
}

const mapStateToProps = state => ({
  newsDetail: state.general.newsDetail
});

const mapDispatchToProps = dispatch => ({
  generalActionCreators: bindActionCreators(generalActions, dispatch)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(NewsDetail);
